import 'flickity/dist/flickity.css'

import Flickity from 'flickity'
export default Flickity

import './__buttons.scss'
